import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: 'Circulate', value: 'circulate' },
  { label: 'Criteo', value: 'criteo' },
  { label: 'Traverse', value: 'traverse' },
  { label: 'Liveramp', value: 'liveramp' },
  { label: 'Sovrn', value: 'sovrn' },
  { label: 'Neustar', value: 'neustar' },
]
